// LC 학습자 이메일 = {아이디}@quebonlc.tv.
// 프론트가 전송 직전 도메인을 붙이고(buildLearnerEmail), 표시 직전 제거한다(learnerHandle).
// 백엔드/DB에는 항상 full email 로 저장된다.

export const LEARNER_EMAIL_DOMAIN = 'quebonlc.tv'
export const LEARNER_EMAIL_SUFFIX = '@quebonlc.tv'

// 허용 아이디 문자(이메일 local part 부분집합). @·공백 불가.
const HANDLE_RE = /^[A-Za-z0-9._%+-]+$/

export type HandleValidation = 'ok' | 'empty' | 'contains_at' | 'invalid_char'

/** 아이디 검증. 양끝 공백은 trim 후 판정(내부 공백/@/기타 문자는 거절). */
export function validateLearnerHandle(raw: string): HandleValidation {
  const v = raw.trim()
  if (v.length === 0) return 'empty'
  if (v.includes('@')) return 'contains_at'
  if (!HANDLE_RE.test(v)) return 'invalid_char'
  return 'ok'
}

/** 전송용: 아이디 → full email. 호출부가 먼저 validate 한 값을 가정. */
export function buildLearnerEmail(handle: string): string {
  return `${handle.trim()}${LEARNER_EMAIL_SUFFIX}`
}

/** 표시용: full email → 아이디. @quebonlc.tv 접미사만 제거, 그 외/널은 원본 유지. */
export function learnerHandle(email?: string | null): string {
  if (!email) return ''
  return email.endsWith(LEARNER_EMAIL_SUFFIX)
    ? email.slice(0, -LEARNER_EMAIL_SUFFIX.length)
    : email
}
